import type { ReactNode } from "react";

/* ---------- Icons (one shared line-icon set) ---------- */

const ip = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

export default function Icon({ name }: { name: string }) {
  const icons: Record<string, ReactNode> = {
    search: (<svg {...ip}><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></svg>),
    context: (<svg {...ip}><path d="M7 3.5h7l3 3V20H7z" /><path d="M14 3.5V7h3M9.5 12h5M9.5 15h5" /></svg>),
    experience: (<svg {...ip}><circle cx="12" cy="8.5" r="4.5" /><path d="M8.2 12.3 6 21l6-3 6 3-2.2-8.7" /></svg>),
    outcome: (<svg {...ip}><circle cx="12" cy="12" r="8.5" /><circle cx="12" cy="12" r="4.5" /><circle cx="12" cy="12" r="1" /></svg>),
    people: (<svg {...ip}><circle cx="8.5" cy="8" r="3" /><path d="M3 20c0-3.3 2.5-6 5.5-6s5.5 2.7 5.5 6M17 5l.8 2.2L20 8l-2.2.8L17 11l-.8-2.2L14 8l2.2-.8z" /></svg>),
    shield: (<svg {...ip}><path d="M12 3l7 3v5c0 5-3 8.5-7 10-4-1.5-7-5-7-10V6z" /><path d="m9 12 2 2 4-4" /></svg>),
    gear: (<svg {...ip}><circle cx="12" cy="12" r="3" /><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1" /></svg>),
    network: (<svg {...ip}><circle cx="6" cy="6" r="2.2" /><circle cx="6" cy="18" r="2.2" /><circle cx="18" cy="12" r="2.2" /><path d="m8 7 8 4M8 17l8-4" /></svg>),
    database: (<svg {...ip}><ellipse cx="12" cy="5.5" rx="7" ry="3" /><path d="M5 5.5v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6M5 11.5v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" /></svg>),
    link: (<svg {...ip}><path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" /></svg>),
    chart: (<svg {...ip}><path d="M5 20V12M10 20V6M15 20v-9M20 20V9M3 20h18" /></svg>),
    finance: (<svg {...ip}><path d="m4 9 8-5 8 5zM6 10v8M10 10v8M14 10v8M18 10v8M4 20h16" /></svg>),
    cart: (<svg {...ip}><circle cx="9" cy="20" r="1.5" /><circle cx="17" cy="20" r="1.5" /><path d="M3 4h3l2.4 11h9.2L20 8H7" /></svg>),
    truck: (<svg {...ip}><path d="M3 6h11v10H3zM14 10h4l3 3v3h-7" /><circle cx="7" cy="18" r="1.8" /><circle cx="17" cy="18" r="1.8" /></svg>),
    factory: (<svg {...ip}><path d="M3 20V9l6 3V9l6 3V5h4v15zM8 20v-3M13 20v-3" /></svg>),
    orders: (<svg {...ip}><rect x="5" y="4" width="14" height="17" rx="1.5" /><path d="M9 4V2.5h6V4M8.5 10h7M8.5 14h7M8.5 18h4" /></svg>),
    speed: (<svg {...ip}><path d="M4 16a8 8 0 1 1 16 0" /><path d="m12 16 4-5" /></svg>),
    control: (<svg {...ip}><path d="M4 19V9M9 19V5M14 19v-7M19 19V8M3 19h18" /></svg>),
    decide: (<svg {...ip}><circle cx="12" cy="12" r="8.5" /><path d="m8.5 12.5 2.5 2.5 4.5-5" /></svg>),
    scale: (<svg {...ip}><path d="M5 19 19 5M10 5h9v9" /></svg>),
    compass: (<svg {...ip}><circle cx="12" cy="12" r="8.5" /><path d="m15.5 8.5-2 5-5 2 2-5z" /></svg>),
    globe: (<svg {...ip}><circle cx="12" cy="12" r="8.5" /><path d="M3.5 12h17M12 3.5c2.5 2.5 3.5 5.3 3.5 8.5s-1 6-3.5 8.5c-2.5-2.5-3.5-5.3-3.5-8.5s1-6 3.5-8.5z" /></svg>),
    flag: (<svg {...ip}><path d="M6 21V4M6 5h11l-2 4 2 4H6" /></svg>),
    cloud: (<svg {...ip}><path d="M7 18a4 4 0 0 1-.6-7.96A5.5 5.5 0 0 1 17 9a4.5 4.5 0 0 1 .5 9z" /></svg>),
    server: (<svg {...ip}><rect x="4" y="4" width="16" height="6" rx="1.5" /><rect x="4" y="14" width="16" height="6" rx="1.5" /><path d="M8 7h.01M8 17h.01" /></svg>),
    lock: (<svg {...ip}><rect x="5" y="11" width="14" height="9" rx="1.5" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></svg>),
    cycle: (<svg {...ip}><path d="M20 11a8 8 0 0 0-14.5-3M4 13a8 8 0 0 0 14.5 3M4 4v4h4M20 20v-4h-4" /></svg>),
  };
  return <>{icons[name] ?? null}</>;
}
